import {Box, Card, List, ListItem, useTheme} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {NOTE_ACTIONS, scrollToNote} from "../../reducers/noteActionSlice"
import {hideSearches,} from "../../reducers/workspaceSearchSlice"
import {selectTargetNote, setTargetNote} from "../../reducers/targetNoteSlice"
import {
	//useEffect,
	useRef
} from "react"
import {getCurrentSearchLastClickedNote, setViewLastClickedId} from "../../reducers/WorkspacePanelScrollSlice"
import {useWorkspaceContext} from "../../pages/Dashboard"

export default function SearchNote({ note, search }) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const scrollRef = useRef()
	const targetNote = useSelector((state) => selectTargetNote(state, workspaceId))
	const currentSearchLastClickedNoteId = useSelector(getCurrentSearchLastClickedNote)
	const theme = useTheme()

	const getHighlightedText = (text, highlight) => {
		const parts = text.split(new RegExp(`(${highlight})`, "gi"))
		return (
			<span>
				{parts.map((part, i) => (
					<span
						key={i}
						style={
							part.toLowerCase() === highlight.toLowerCase()
								? { backgroundColor: "#FFFF00" }
								: {}
						}
					>
						{part}
					</span>
				))}
			</span>
		)
	}

	const handleClick = (e) => {
		e.stopPropagation()
		dispatch(setViewLastClickedId({noteId: note.id, workspaceId}))
		dispatch(hideSearches(workspaceId))
		dispatch(
			scrollToNote({
				note: note,
				action: NOTE_ACTIONS.scrollToNote,
				noteId: note.id,
				path: note.path,
				showLoading: true
			})
		)
		dispatch(setTargetNote({workspaceId, note}))
	}

	return (
		<List
			variant={"notetree"}
			toplevel={note?.parentId === null ? "true" : "false" }
			dense
		>
			<ListItem
				variant={"notetree"}
				toplevel={note?.parentId === null ? "true" : "false" }
				onClick={handleClick}
			>
				<Box
					// We place the scroll ref AND the noteId inside the <Box> to prevent the target of the scroll
					ref={scrollRef}
					id={note?.id}
					sx={{ display: "flex", paddingTop: "1px",}}
				>
					<span style={{ maxWidth: "25px", minWidth: "25px" }} />
					<Card
						variant={"note"}
						elevation={2}
						sx={{
							width: "100%",
							padding: "5px",
							minHeight: "30px",
							border: targetNote.id === note.id ? `2px solid ${theme.palette.primary.main}` : currentSearchLastClickedNoteId === note.id ? "notes.moveNoteIndicatorAccent" : "none",
							backgroundColor: targetNote.id === note.id ? "notes.selected" : currentSearchLastClickedNoteId === note.id ? "notes.moveNoteIndicator" : "white",
							wordBreak: "break-word",
							display: "flex",
							alignItems: "center"
						}}
					>
						{getHighlightedText(note.content, search.query)}
					</Card>
				</Box>
				{note.children.map((child) => (
					<SearchNote
						key={child.id}
						note={child}
						search={search}
					/>
				))}
			</ListItem>
		</List>
	)
}
